import { Button, FormFieldGroup, TextInput } from '@resurs-internal/styx-react'
import React, { useContext, useState } from 'react'
import { PageContext } from './ContentContext'
import styles from './EditPagesRoute.module.scss'

export const Login = () => {
  const { login } = useContext(PageContext)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  return (
    <form
      className={styles.login}
      onSubmit={e => {
        e.preventDefault()
        login({ username, password })
      }}
    >
      <FormFieldGroup>
        <TextInput
          id="username"
          label="Username"
          value={username}
          onChange={(id, value) => setUsername(value)}
        />
        <TextInput
          id="password"
          label="Password"
          type="password"
          value={password}
          onChange={(id, value) => setPassword(value)}
        />
      </FormFieldGroup>
      <Button id="login-button" type="primary" form>
        Log in
      </Button>
    </form>
  )
}
